import React from 'react';
import VippsTimeout from './timeout.svg';
import MobilepayTimeout from './timeout-mp.svg';
import { useAppContext } from '../../core/context';
import { Brand, getBrandFromQueryParamOrClaimsOrHost } from '../../core/context/claims';

function Timeout(): React.ReactNode {
  const context = useAppContext();
  const brand = getBrandFromQueryParamOrClaimsOrHost(context.claims);
  return (
    <img
      src={brand === Brand.MOBILEPAY ? MobilepayTimeout : VippsTimeout}
      alt=""
      aria-hidden="true"
    />
  );
}

export default Timeout;
